<template>
  <AttrBase
    v-slot="{ hover }"
    :label="label"
    :tooltip="tooltip"
    :disabled="disabled"
  >
    <icon
      v-if="allowClear && hover && !disabled && !!value"
      icon="delete2.svg"
      class="w-3 h-3 cursor-pointer mr-1"
      @click="() => emit('change', undefined)"
    />
    <div
      class="flex items-center cursor-pointer justify-end px-3 -mr-3 border border-transparent transition-all"
      :class="{
        ' !border-border-active': hover && !disabled,
        ' attr-disabled': disabled
      }"
      :style="{
        minWidth: width + 'px',
        minHeight: '34px'
      }"
      @click.stop="onClick"
    >
      <span
        class="mr-2 text-sm font-medium opacity-[0.3]"
        :class="{ 'opacity-[1.0]': option?.label }"
      >
        {{ option?.label ?? '请选择' }}
      </span>
      <icon icon="arrow-down.svg" :width="14" :height="14" fill="none" />
    </div>

    <AttrSelectOptions
      ref="optionRef"
      :value="_val"
      :options="options"
      :search="search"
      @change="onSelect"
    />
  </AttrBase>
</template>
<script lang="ts" setup>
import { PropType, computed, ref, watch } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number, Boolean] as PropType<string | number | boolean>,
    default: undefined
  },
  disabled: {
    type: Boolean,
    default: false
  },
  width: {
    type: Number,
    default: 100
  },
  options: {
    type: Array as PropType<
      {
        label: string;
        value: string | number | boolean;
        oldValue?: string;
        disabled?: boolean;
      }[]
    >,
    default: () => []
  },
  search: {
    type: Boolean,
    default: false
  },
  tooltip: {
    type: String,
    default: ''
  },
  allowClear: {
    type: Boolean,
    default: false
  }
});

const optionRef = ref();

const _val = ref<string | number | boolean>();
watch(
  () => props.value,
  (v) => {
    if (v !== undefined) _val.value = v;
  },
  { immediate: true }
);
const option = computed(() =>
  props.options.find(
    (item) => item.value == _val.value || item.oldValue == _val.value
  )
);

const emit = defineEmits<{
  (event: 'change', val: typeof _val.value): void;
}>();
const onSelect = (v: typeof _val.value) => {
  if (props.disabled) return;
  if (v != props.value) emit('change', v);
};

const onClick = () => {
  if (props.disabled) return;
  optionRef.value?.open?.();
};
</script>

<style lang="less" scoped>
// :deep() {
// }
</style>
